<template>
  <div id="others" style="padding: 0 1em;">
    <div v-html="content" style="text-align:left;"/>
  </div>
</template>

<script>
export default {
  name: 'Others',
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    }
  },
  data () {
    return {
      content: ''
    }
  },
  created () {
    console.log('======created=====')
    var vm = this
    this.$http
        .get('./WebApi/Apply/GetOthersInfo/'.concat(this.sysId))
        .then(function(response) {
          vm.content = response.data
        })
        .catch(function (error) {
          //this.$message.error('對不起,網路連線失敗');
          vm.$notify.error({
            title: vm.$t('message.Error_txt'),
            dangerouslyUseHTMLString: true,
            message: '<strong>對不起,網路連線失敗' + error+'</strong>',
            offset: 150
          });
        })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#others {
    min-height: 20px;
    padding: 19px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/OthersView.vue